import { connect } from 'react-redux';
import NavigationLayout from './layout';
import { setCurrentEntity, setSelectedEntityId, setConfirmationDialog } from '../../redux/modules/entities';

import {
  authenticatedAndBrandingReady,
  getAvailableTenants,
  currentTenantId,
  getCurrentTenantName,
  getCurrentAgentName,
  getCurrentAgentFullName,
  getAccountTenants,
  getTenantsList,
} from '../../redux/modules/userData/selectors';
import { getTenantWFMUrl, getTenantWFMPlayBook, userHasWFMPermissions,getMenuPermissions } from "../../redux/modules/entities/tenants/selectors"
import { setUserAuthed, switchTenant } from '../../redux/modules/userData';
import { getCustomTheme } from '../../redux/modules/entities/branding/selectors';
import { getCustomlogo ,getCustomFavicon } from '../../redux/modules/entities/branding/selectors';
import { isFormDirty, areSubEntityFormsDirty } from '../../redux/modules/form/selectors';
import { fetchBranding } from "../../redux/modules/entities/branding/actions";

export function mapStateToProps(state, props) {
  return {
    accountTenants: getAccountTenants(state),
    areSubEntityFormsDirty: areSubEntityFormsDirty(state),
    authenticatedAndBrandingReady: authenticatedAndBrandingReady(state),
    currentTenantId: currentTenantId(state),
    currentTenantName: getCurrentTenantName(state),
    currentUserName: getCurrentAgentFullName(state),
    isCurrentFormDirty: isFormDirty(state),
    tenants: getAvailableTenants(state),
    tenantsList: getTenantsList(state),
    theme: getCustomTheme(state),
    logo: getCustomlogo(state),
    favicon:getCustomFavicon(state),
    userHasWFMPermissions: userHasWFMPermissions(state),
    wfmPlayBookUrl: getTenantWFMPlayBook(state),
    menuPermissions: getMenuPermissions(state),
    wfmUrl: getTenantWFMUrl(state),
  };
}

export const actions = {
  switchTenant,
  setCurrentEntity,
  setSelectedEntityId,
  setConfirmationDialog,
  setUserAuthed,
  fetchBranding,
};

export default connect(mapStateToProps, actions)(NavigationLayout);
